<template>
  <main class="page-investors-show py-5">
    <div class="container">
      <AwlCard v-if="investor">
        <p class="h3">{{investor.name}} {{investor.surname}}</p>
      </AwlCard>
    </div>
  </main>
</template>

<script>
import $api from '../../../../libs/Api/services/api';

export default {
  name: 'page-investors-show',
  components: {
    AwlCard: () => import('../../../components/Layout/Card/AwlCard'),
  },
  data () {
    return {
      investor: {
        name: 'Marco',
        surname: 'Verdi',
      },
    };
  },
  async beforeRouteEnter (to, from, next) {
    try {
      const res = await $api.investor(to.params.id);
      return next(vm => {
        vm.investor = res.data;
      });
    } catch (error) {
      return next(vm => vm.$log.error(error));
    }
  },
};

</script>

<style lang="scss">
  .page-investors-show {
    .awl-card {
      margin: 0 auto;
      max-width: 750px;
    }
  }
</style>
